import { type ReactElement } from 'react'
import { messageFromError } from '@terros/common'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { mergeGetHookResponses, usePermissionCheck, useProfile, useTranslation } from '@front/model'
import { NotReady, Page, TAlert, TButton } from '@components'
import { ComparePermissions } from '../ComparePermissions'

export const ComparePermissionsPage = (): ReactElement => {
  const { t } = useTranslation()
  const router = useRouter()
  const profileState = useProfile()
  const { company } = profileState
  const permissionState = usePermissionCheck({
    permissionType: 'user:manage',
    targetId: company?.companyId,
  })
  const state = mergeGetHookResponses([profileState, permissionState])

  const handleBack = (): void => {
    if (router.history.canGoBack()) {
      router.history.back()
      return
    }
    router.navigate({ to: '/settings/permissions' })
  }

  if (state.isLoading || state.error || !company)
    return <NotReady error={messageFromError(state.error)} isLoading={state.isLoading} />

  return (
    <Page>
      <Page.Heading title={t('Compare permissions')}>
        <TButton icon='arrow_back' variant='secondary' onClick={handleBack}>
          {t('Back to permissions')}
        </TButton>
      </Page.Heading>
      <Page.Content scrollArea>
        {permissionState.data ? (
          <ComparePermissions />
        ) : (
          <TAlert>
            {t('You do not have permission to view permissions for {{companyName}}', {
              companyName: company.name,
            })}
          </TAlert>
        )}
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/settings/permissions/compare/')({
  component: ComparePermissionsPage,
})
